import { useHead, useScript } from '@unhead/react';

const isEnabled = import.meta.env.VITE_ENABLE_GTM === 'true';
const GTM_ID = import.meta.env.VITE_GTM_ID;

export const useGtmScript = (delayMs: number = 2000) => {
  // Synchronously inject dataLayer and initial event
  useHead({
    script:
      isEnabled && GTM_ID
        ? [
            {
              innerHTML() {
                return `
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
        `;
              },
              key: 'gtm-init',
            },
          ]
        : [],
  });

  // Defer loading of the GTM script
  useScript(
    isEnabled && GTM_ID
      ? {
          src: `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`,
          async: true,
          crossorigin: undefined,
          referrerpolicy: undefined,
        }
      : { src: '' },
    {
      key: 'gtm-script',
      trigger:
        isEnabled && GTM_ID
          ? new Promise((resolve) => setTimeout(resolve, delayMs))
          : null,
    }
  );
};
